import React from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';
import Loading from 'components/loading';
import { classNames } from 'utils';

import './status.scss';

export default function Status({
  children,
  className,
  blank = false,
  type = 'positive',
  radius = 'rounded',
  size = 'sm',
  tag = true,
  dot = true,
  loading = false,
  prefixText = null,
  faIcon = null,
}) {
  return children ? (
    <span
      className={classNames('status', className, type, size, tag && radius, {
        tagless: !tag,
      })}
    >
      {loading ? (
        <Loading size={size === 'sm' ? 14 : size === 'md' ? 16 : 20} />
      ) : (
        dot && <span className="status-dot" />
      )}
      {prefixText && <div className="prefix">{prefixText}</div>}
      {children}
      {faIcon && <Icon fa={faIcon} className="icon" />}
    </span>
  ) : blank ? null : (
    <span className="muted">&mdash;</span>
  );
}

Status.propTypes = {
  className: pt.string,
  type: pt.string,
  dot: pt.bool,
  blank: pt.bool,
  tag: pt.bool,
  loading: pt.bool,
  radius: pt.oneOf(['rounded', 'rounded-4xl', 'rounded-full']),
  children: pt.node,
  size: pt.oneOf(['sm', 'md']),
  prefixText: pt.string,
  faIcon: pt.string,
};
